import { trackPageView } from '../analytics';

export function replaceHistory(data: any, title: string, url?: string) {
    trackPageView(url);
    window.history.replaceState(data, title, url);
}
